import PropTypes from 'prop-types';
import React from 'react';
import styles from './AvailableChildOptions.scss';

const AvailableChildOptions = ({ heading, options }) => {
  return (
    <div className={styles['available-child-options']}>
      <div className={styles['heading']}>{heading}</div>
      {options.length > 0 && (
        <ul>
          {options.map((option) => {
            const { codeValue, description, isOutOfStock, isSoldOut } = option;
            return (
              <li
                className={`${styles['option']}${
                  isOutOfStock ? ` ${styles['out-of-stock']}` : isSoldOut ? ` ${styles['sold-out']}` : ''
                }`}
                key={codeValue}>
                {description}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

AvailableChildOptions.propTypes = {
  heading: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      codeValue: PropTypes.string.isRequired,
      colorGroupList: PropTypes.arrayOf(PropTypes.string).isRequired,
      colorReference: PropTypes.string.isRequired,
      componentId: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      estimatedShipDate: PropTypes.string.isRequired,
      futureShipDateSettingStatus: PropTypes.oneOf([0, 1, 2]).isRequired,
      helpLink: PropTypes.shape({
        helpText: PropTypes.string.isRequired,
        linkText: PropTypes.string.isRequired,
      }),
      inventoryMessage: PropTypes.string.isRequired,
      isFutureShipDateSettable: PropTypes.bool.isRequired,
      isOutOfStock: PropTypes.bool.isRequired,
      isSelected: PropTypes.bool.isRequired,
      isSoldOut: PropTypes.bool.isRequired,
      itemId: PropTypes.string.isRequired,
      optionText: PropTypes.string.isRequired,
      outOfStockMessage: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
      sequence: PropTypes.number.isRequired,
      specialBomCharge: PropTypes.string.isRequired,
      useTexture: PropTypes.bool.isRequired,
      yearOptionPricing: PropTypes.oneOf([0, 1, 2]).isRequired,
    })
  ).isRequired,
};

export default AvailableChildOptions;
